import { FC, ReactNode } from "react";
import Popup from "reactjs-popup";
import ClosingCrossIconSVG from "../shared/svg/ClosingCrossSVG";
import useBodyFixed from "../../custom-hooks/base-hooks/useBodyFixed";

interface BaseModalProps {
    children: ReactNode;
    buttonElement?: ReactNode; // тепер цей button використовується
    customConfirmButton?: ReactNode;
    title: string;
    confirmTitle?: string;
    cancelTitle?: string;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
    confirmHandler: () => void;
    closeHandler?: () => void;
    onOpen?: () => void;
    additionalWrapClassName?: string;
    additionalChildWrapClassName?: string;
    additionalButtonClassName?: string;
    additionalConfirmButtonClassName?: string;
    additionalTitleClassName?: string;
    disableCancelButton?: boolean;
    closingCrossClassName?: string;
    confirmButtonDisabled?: boolean;
}

const BaseModal: FC<BaseModalProps> = (props) => {
    const { fixed, unfixed } = useBodyFixed();

    const openHandler = () => {
        props.onOpen && props.onOpen();
        fixed();
    };

    const closeHandler = () => {
        props.setIsVisible(false);
        props.closeHandler && props.closeHandler();
        unfixed();
    };

    return (
        <>
            {/* Використовуємо саме переданий buttonElement */}
            {props.buttonElement && props.buttonElement}

            <Popup
                onOpen={openHandler}
                open={props.isVisible}
                modal
                overlayStyle={{ zIndex: 99999, backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                onClose={closeHandler}
            >
                <div
                    id="static-modal"
                    data-modal-backdrop="static"
                    className={`overflow-y-auto overflow-x-hidden top-0 right-0 left-0 justify-center items-center h-[calc(100%-1rem)] ${props.additionalWrapClassName}`}
                >
                    <div className="relative px-4 w-full max-h-full">
                        {/* Modal content */}
                        <div
                            className={`relative  bg-light-bg-1000 dark:bg-dark-bg-100 rounded-lg shadow ${props.additionalChildWrapClassName}`}
                        >
                            {/* Modal header */}
                            <div className="flex items-center justify-between p-4 rounded-t">
                                <h3
                                    className={`text-xl font-semibold text-light-text-200 dark:text-dark-text-400  ${props.additionalTitleClassName}`}
                                >
                                    {props.title}
                                </h3>
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    data-modal-hide="static-modal"
                                    onClick={closeHandler}
                                >
                                    <ClosingCrossIconSVG
                                        className={`w-5 h-5 text-light-text-200 dark:text-dark-text-400 ${
                                            props.closingCrossClassName || ""
                                        }`}
                                    />
                                </button>
                            </div>

                            {/* Modal body */}
                            <div className="p-4 max-h-[75vh] overflow-auto">{props.children}</div>

                            {/* Modal footer */}
                            {props.customConfirmButton ? (
                                props.customConfirmButton
                            ) : (
                                <div className="flex justify-center items-center p-4 rounded-b">
                                    <button
                                        data-modal-hide="static-modal"
                                        type="button"
                                        className={
                                            "w-32 text-white bg-light-bg-300 dark:bg-dark-bg-300 hover:bg-light-bg-300 dark:hover:bg-dark-bg-400 font-medium rounded-lg text-sm px-5 py-2.5 text-center" +
                                            (props.additionalConfirmButtonClassName
                                                ? ` ${props.additionalConfirmButtonClassName}`
                                                : "") +
                                            (props.confirmButtonDisabled ? " opacity-50 cursor-not-allowed" : "")
                                        }
                                        onClick={props.confirmHandler}
                                        disabled={props.confirmButtonDisabled}
                                    >
                                        {props.confirmTitle}
                                    </button>
                                    {!props.disableCancelButton && (
                                        <button
                                            data-modal-hide="static-modal"
                                            type="button"
                                            className="w-32 py-2.5 px-5 ms-3 text-sm font-medium  bg-white rounded-lg border border-gray-200 hover:bg-gray-100 text-gray-900 hover:text-gray-1000"
                                            onClick={closeHandler}
                                        >
                                            {props.cancelTitle}
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default BaseModal;
